export const getPermissionsList = (state) => state.permissions.permissions